// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14yKK","type":"styles_type__3hOLm","choices":"styles_choices__VfYfA"};